import EnhancedTableHead from './EnhancedTableHead';

export default EnhancedTableHead;
